// src/components/admin/CouponTable.jsx
import React from 'react';

export default function CouponTable({ coupons, onEdit, onReload }) {
  return (
    <div className="bg-white border rounded shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Existing Coupons</h3>
      <table className="w-full text-sm">
        <thead className="text-left">
          <tr>
            <th className="px-2 py-1">Promo Code</th>
            <th className="px-2 py-1">Type</th>
            <th className="px-2 py-1">Value</th>
            <th className="px-2 py-1">Duration</th>
            <th className="px-2 py-1">End Date</th>
            <th className="px-2 py-1">Country</th>
            <th className="px-2 py-1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {coupons.map(coupon => (
            <tr key={coupon._id}>
              <td className="px-2 py-1">{coupon.promotionCode}</td>
              <td className="px-2 py-1">{coupon.discountType}</td>
              <td className="px-2 py-1">{coupon.discountValue}</td>
              <td className="px-2 py-1">
                {coupon.duration}
                {coupon.duration === 'repeating' ? ` (${coupon.durationInMonths} mo)` : ''}
              </td>
              <td className="px-2 py-1">{coupon.promotionExpiresAt ? new Date(coupon.endDate).toLocaleDateString() : '—'}</td>
              <td className="px-2 py-1">{coupon.country?.name || '—'}</td>
              <td className="px-2 py-1">
                <button className="text-blue-600 text-xs underline" onClick={() => onEdit(coupon)}>Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
